// extracted by mini-css-extract-plugin
export var borderRadius = "_51-4";
export var large = "_51-3";
export var logoContainer = "_51-0";
export var nameLogo = "_51-2";
export var small = "_51-1";